import React from 'react'
import StrategyIco from '../Images/strategy-ico.avif'
import CreativityIco from '../Images/creativity-ico.avif'
import BeyondIco from '../Images/beyond-ico.avif'
import RoundText from '../Components/RoundText'
import './Hero.scss'

const Hero = () => {
    return (
        <div className='hero full-width'>
            <div className='content main-grid'>
                <div className='hero-left'>
                    <h1 className='bungee-font'>IDEAS CONNECT <br />
                        THROUGH</h1>
                    <div className='two-columns'>
                        <div className='left'>
                            <p className='inter-font'>
                                Our UX/UI solutions are designed with the user in mind, ensuring that every interaction is enjoyable and effective. We create unique designs that not only look great but, most importantly, deliver positive experiences for your customers.
                            </p>
                        </div>
                        <div className='right'>
                            <div className='icon-div'>
                                <img src={StrategyIco} alt='' className='icon strategy-icon' />
                                <h2 className='unbounded-font'>STRATEGY</h2>
                            </div>
                            <div className='icon-div'>
                                <img src={CreativityIco} alt='' className='icon creativity-icon' />
                                <h2 className='unbounded-font'>CREATIVITY</h2>
                            </div>
                            <div className='icon-div'>
                                <img src={BeyondIco} alt='' className='icon beyond-icon' />
                                <h2 className='unbounded-font'>BEYOND</h2>
                            </div>


                        </div>
                    </div>
                    <RoundText
                        height='169px'
                        className='hero-round-text'
                    />


                </div>
                <div className='hero-right'>

                </div>
            </div>
        </div>
    )
}

export default Hero